<script lang="ts">
  import { EditButton } from './';
  import type { EditButton as EditButtonProp } from './types';
  import { cn } from '$lib/utils';
  export let button: EditButtonProp = {
    editUrl: '#',
    text: 'Edit'
  };
  export let isDev: boolean = false;
</script>

<div class={cn({ 'group hover:outline-orange-600 hover:outline': isDev }, 'relative')}>
  <EditButton {button} />
  <slot />
</div>
